/* eslint-disable sonarjs/no-duplicate-string */
import { newSpecPage } from '@stencil/core/testing'
import { CobaltTooltip } from '../cobalt-tooltip'

describe('cobalt-tooltip', () => {
  it('should render tooltip element', async () => {
    const page = await newSpecPage({
      components: [CobaltTooltip],
      html: '<cobalt-tooltip><span slot="trigger-element">Hover Me</span><span slot="tooltip-content">Tooltip message</span></cobalt-tooltip>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-tooltip class="typography-body-small-regular" direction="top">
        <core-tooltip direction="top" tooltipbackgroundcolor="color-neutral-background-strong" tooltipcolor="color-neutral-content-medium" tooltippadding="var(--number-spacing-4xsmall) var(--number-spacing-3xsmall)">
          <span slot="trigger-element">
            Hover Me
          </span>
          <span slot="tooltip-content">
            Tooltip message
          </span>
        </core-tooltip>
      </cobalt-tooltip>
    `)
  })
  it('should call toggleTooltip on hover', async () => {
    const page = await newSpecPage({
      components: [CobaltTooltip],
      html: '<cobalt-tooltip><span slot="trigger-element">Hover Me</span><span class="tooltip-content">Tooltip message</span></cobalt-tooltip>'
    })
    const tooltip = page.root

    const toggleTooltip = jest.fn()

    tooltip.addEventListener('mouseenter', toggleTooltip)
    tooltip.dispatchEvent(new MouseEvent('mouseenter'))

    expect(toggleTooltip).toHaveBeenCalledTimes(1)
  })
})
